import React, { useContext, useEffect, useState } from 'react';
import LanguageHeader from './LanguageHeader';
import { AuthContext } from '../../AuthContext';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function Header() {
  const { authState, logout, clientLoginformData } = useContext(AuthContext);
  const [showTrainingSection, setShowTrainingSection] = useState(false);
  const { slug } = useParams();

  useEffect(() => {
    if (authState.token && authState.user.role !== 1) {
      checkTrainingAvailability();
      setInterval(() => {
        checkTrainingAvailability();
      }, 5000);
    }
  }, [authState.token]);

  const checkTrainingAvailability = async () => {
    const response = await fetch(`/auth/training-status/${authState.user._id}`);
    const status = await response.json();

    if (!status.motivetraining && status.timeRemaining === 0) {
      console.log('status', status);
      setShowTrainingSection(true);
    } else {
      setShowTrainingSection(false);
    }
  };

  if (authState.token) {
    return (
      <div className="header">
        <div className="header-left">
          <div className="search-toggle-icon bi bi-search" data-toggle="header_search"></div>
          <div className="header-search">
            <LanguageHeader />
          </div>
        </div>
        <div className="header-right">
          {showTrainingSection && (
            <div style={{ display: 'flex', gap: '10px' }}>
              <div class="card-body">
                <h6>Motive Training Status</h6>
                <Link to={`/view-avatar-settings/${authState.user._id}`}>
                  <p id="trainingStatus" class="text-warning">
                    Training Required
                  </p>
                </Link>
              </div>
            </div>
          )}

          <div className="user-info-dropdown">
            <div className="dropdown">
              <a className="dropdown-toggle" href="#" role="button" data-toggle="dropdown">
                <span className="user-icon">
                  <img src="/vendors/images/photo1.jpg" alt="" />
                </span>
                <span className="user-name">{authState.user?.company_name}</span>
              </a>
              <div className="dropdown-menu dropdown-menu-right dropdown-menu-icon-list">
                <a className="dropdown-item" href={`/view-profile/${authState.user?._id}`}>
                  <i className="dw dw-user1"></i> Profile
                </a>
                <a className="dropdown-item" href="/backend">
                  <i className="dw dw-settings2"></i> Setting
                </a>

                <a className="dropdown-item" href="javascript:void(0)" onClick={logout}>
                  <i className="dw dw-logout"></i> Log Out
                </a>
              </div>
            </div>
          </div>
          {/* <div className="github-link">
                        <a href="https://github.com/dropways/deskapp" target="_blank" rel="noopener noreferrer">
                            <img src="vendors/images/github.svg" alt="" />
                        </a>
                    </div> */}
        </div>
      </div>
    );
  } else {
    return (
      <div className="login-header box-shadow">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="brand-logo">
            <a
              href="/"
              style={{
                color: clientLoginformData ? clientLoginformData?.button_color : '#eb8d16',
                fontWeight: 'bold',
              }}
            >
              {clientLoginformData ? clientLoginformData?.header_text : 'AI Human'}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
